import script from "./AppImagePreview.vue?vue&type=script&setup=true&lang=js"
export * from "./AppImagePreview.vue?vue&type=script&setup=true&lang=js"

import "./AppImagePreview.vue?vue&type=style&index=0&id=112b4488&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-112b4488"]])

export default __exports__